import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useParams } from 'react-router-dom';

import { Loader, Placeholder } from 'rsuite';

import { retrieve, update } from './actions/Event';

export default function Event() {
  const { server_id, admin_id } = useParams();
  const [EventData, setEventData] = useState([]);
  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();
  useEffect(() => {
    fetchEvent(server_id, admin_id);
  }, [server_id, admin_id]);


  let fetchEvent = (server_id, admin_id) => {
    setLoading(true);
    let data = {
      server_id: server_id ? server_id : '',
      admin_id: admin_id ? admin_id : '',
      limit: 1,
      last_id: '',
      first_id: '',
    };
    dispatch(retrieve(data)).then((response) => {
      setLoading(false);
      // console.log(response)
      setEventData(response?.data);
    });
  }

  let handleAccess = (device_id, access) => {
    let data = {
      server_id: server_id ? server_id : '',
      admin_id: admin_id ? admin_id : '',
      device_id: device_id,
      access: access,
    }
    dispatch(update(data)).then((response) => {
      // console.log(response);
      setLoading(false);
      fetchEvent(server_id, admin_id);
    });
  }


  let formatDateTime = (date) => {
    return date;
    console.log(date)
    // if(date && date.length > 0 && time && time.length > 0 && format == 'd/m/y H:i a') {
    //   // console.log(date, time)
    //   let tempDay = date.split('/')[0]
    //   let tempMonth = date.split('/')[1]
    //   let tempYear = date.split('/')[2]
    //   let time_ = time.split(' ')[0];
    //   let hour = time_.split(':')[0];
    //   hour = parseInt(time_.split(':')[0]);
    //   let minute = time_.split(':')[1];
    //   if(time.split(' ')[1] == 'PM') {
    //     return new Date(tempYear + '-' + tempMonth + '-' + tempDay + ' ' + (hour < 12 ? hour < 10 ? hour + 12 : hour + 12 : hour) + ':' + minute + ':00').toISOString();
    //   } else {
    //     return new Date(tempYear + '-' + tempMonth + '-' + tempDay + ' ' + (hour < 12 ? '0' + hour : hour) + ':' + minute + ':00').toISOString();
    //   }
    // } else {
    //   return new Date().toISOString();
    // }
  }
  return (
    <>
      {loading ?
        <div>
          <Placeholder.Paragraph rows={8} />
          <Loader center content="loading" />
        </div>
        :
        <>
          <div className='row'>
            <h4 className='fg-theme mb-2 mt-2'>Events</h4>
            {
              EventData && EventData?.length > 0 ?
                EventData.map((val, index) => {
                  return(
                    <div className='col-md-6 col-lg-4 col-sm-12 mt-1'>
                      <div className='card'>
                        <div className='card-body'>
                          <h4 className='fg-theme mb-2 mt-2'>{val?.data?.type ?  val?.data?.type : ''}</h4>
                          {/* <h4 className='fg-theme mb-2 mt-2'>{val?.data?.admin_user ? val?.data?.admin_user ? val?.data?.admin_user : '' : ''}</h4> */}
                          <p>Admin : {val?.data?.adminID ? val?.data?.adminID : ''}</p>
                          <p>Staff : {val?.data?.staffID ? val?.data?.staffID : ''}</p>
                          <p>User : {val?.data?.userID ? val?.data?.userID : ''}</p>
                          <p>Notes : {val?.data?.notes ? val?.data?.notes : ''}</p>
                          {/* <p>Document : {val?.data?.document ? val?.data?.document : ''}</p> */}
                          <p>Requested At : {Date(val?.data?.createdAt ? val?.data?.createdAt : '')}</p>
                          {/* <p>Create Date : {formatDateTime(val?.data?.added_on ? val?.data?.added_on : '')}</p> */}
                          {/* <p>Deleted : <i className={`fa fa-${!val?.data?.status ? val?.data?.status : ''?'toggle-on fg-green':'toggle-off fg-red'}`}></i></p>
                          <p>Status : <span className='text-uppercase'>{val?.data?.status ? val?.data?.status : ''}</span></p> */}
                          {/* <p>Access : {val.access?'TRUE':'FALSE'}</p> */}
                        </div>
                      </div>
                    </div>
                  )
                })
              : ''
            }
          </div>
        </>
      }
    </>
  )
}